'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('video-answer-view', {
		props: ['answer'],
		mounted: function () {
			this.$nextTick(function () {
				this.renderVideo();
			})
		},
		watch: {
			answer: function () {
				this.renderVideo();
			},
		},
		methods: {
			renderVideo: function () {
				var _self = this;

				if (_self.answer.content) {
					setTimeout(function () {  internals.addVideo(_self.answer.content, _self.$el); }, 250);
				}
			}
		},
		template:
		'<div class="answer-video"></div>',
	});

	// workaround
	internals.addVideo = function (video, el) {
		var id = utils.generateUUID();

		var videoElement = $('<div class="' + id + '" data-video-url="' + video + '"></div>');

		$(el).html(videoElement);

		$('.' + id).customVideo();
	};
});
